// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"b38173af","114":"9cc8f896","132":"47c5223f","271":"b8be3b8d","319":"44df1d1f","449":"58b1ce6c","728":"b2f12fde","748":"a67be8cd","798":"00dfd300","897":"e79c38e6"}[chunkId] + ".chunk.js";
};